import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Analytics from "@/pages/Analytics";
import Billing from "@/pages/Billing";
import Owner from "@/pages/Owner";
import Legal from "@/pages/Legal";
import Referral from "@/pages/Referral";
import FacebookCallback from "@/pages/FacebookCallback";
import { AuthProvider } from "@/context/AuthContext";
import { FeedbackWidget } from "@/components/FeedbackWidget";

function AppRouter() {
  const location = useLocation();

  // Handle Emergent OAuth callback: session_id is in the URL hash fragment.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  // Hide the feedback bubble on auth screens & owner console.
  const hideFeedback =
    ["/login", "/signup", "/owner"].includes(location.pathname);

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Auth mode="login" />} />
        <Route path="/signup" element={<Auth mode="signup" />} />
        <Route path="/app" element={<Dashboard />} />
        <Route path="/app/analytics" element={<Analytics />} />
        <Route path="/app/billing" element={<Billing />} />
        <Route path="/app/billing/success" element={<Billing />} />
        <Route path="/owner" element={<Owner />} />
        <Route path="/privacy" element={<Legal page="privacy" />} />
        <Route path="/terms" element={<Legal page="terms" />} />
        <Route path="/refund" element={<Legal page="refund" />} />
        <Route path="/app/referral" element={<Referral />} />
        <Route path="/auth/facebook/callback" element={<FacebookCallback />} />
      </Routes>
      {!hideFeedback && <FeedbackWidget />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
